/* eslint-disable import/prefer-default-export */
import { BitmapLayer } from '@deck.gl/layers';
import { TileLayer } from '@deck.gl/geo-layers';
import { Layer as FulcrumLayer } from '../../../models/layer';

export function convertXyzLayerToMapLayer(fulcrumLayer: FulcrumLayer): TileLayer {
  try {
    const url = new URL(fulcrumLayer.source);
  } catch (err) {
    throw new Error(`Invalid source for layer: ${fulcrumLayer.name}`);
  }

  return new TileLayer({
    id: fulcrumLayer.id,
    data: fulcrumLayer.source,
    minZoom: 0,
    maxZoom: 22,
    tileSize: 256,
    updateTriggers: {
      getTileData: [fulcrumLayer],
    },
    renderSubLayers: (props: any) => {
      const {
        bbox: {
          west, south, east, north,
        },
      } = props.tile;

      return new BitmapLayer(props, {
        data: null,
        image: props.data,
        bounds: [west, south, east, north],
      });
    },
  });
}
